import React from "react";

export default function FullScreenLoader({ label = "Loading..." }) {
  return (
    <div style={styles.overlay}>
      <div style={styles.spinner} />
      <span style={styles.text}>{label}</span>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },

  spinner: {
    width: 120,
    height: 120,
    border: "12px solid rgba(255, 255, 255, 0.2)",
    borderTop: "12px solid #2275FF",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },

  text: {
    marginTop: 16,
    color: "#fff",
    fontSize: "1rem",
    letterSpacing: "0.05em",
    fontFamily: "Montserrat",
  },
};
